import React, { useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import EventReportDisplay from './EventReportDisplay';
import EventReportModal from './EventReportModal';

const GenerationProgress = ({ status, elapsed }) => (
  <div className="event-detail-progress">
    <ArrowPathIcon />
    <div>
      <strong>{status?.current_step || 'Generating statistics'}</strong>
      <span>
        {elapsed || 'working'}
        {status?.progress > 0 ? ` · ${status.progress}%` : ''}
      </span>
    </div>
  </div>
);

/** Aggregated event statistics, with the progress of a running generation or a button to start one. */
export default function EventStatisticsTab({ event, eventId, statistics, onPublished }) {
  const [isGenerateOpen, setIsGenerateOpen] = useState(false);
  const handleStarted = (result) => {
    if (result === 'started') statistics.refresh();
  };

  return (
    <div className="event-stats-tab">
      <div className="event-stats-tab-head">
        <div>
          <h2>Event statistics</h2>
          <p>Aggregated numbers across the reported sessions. Separate from custom reports.</p>
        </div>
        {statistics.running ? (
          <GenerationProgress status={statistics.status} elapsed={statistics.elapsed} />
        ) : (
          <button type="button" className="event-detail-btn" onClick={() => setIsGenerateOpen(true)}>
            <ArrowPathIcon /> Generate statistics
          </button>
        )}
      </div>
      <EventReportDisplay key={statistics.revision} eventId={eventId} eventUrl={event?.url} onPublished={onPublished} />

      <EventReportModal
        isOpen={isGenerateOpen}
        onClose={() => setIsGenerateOpen(false)}
        event={event}
        onReportGenerated={handleStarted}
      />
    </div>
  );
}
